import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

// 下面开始基本配置菜单
const menu_set = () => import("@/components/base_business/menu_set"); //菜单内容设置
const pwd_set = () => import("@/components/base_business/person_pwd_set"); //个人密码修改
const sys_set = () => import("@/components/base_business/system_set"); //系统参数修改
const sys_select = () => import("@/components/base_business/system_select"); //系统参数修改
const c_menu_set = () => import("@/components/base_business/count_menu_set"); //初始业务统计范围
const home_set = () => import("@/components/base_business/sys_home_set"); //首页提醒设置
const home_base=() => import("@/components/base_business/sys_home_base"); //首页提醒配置

const user_set = () => import("@/components/base_business/person_data_set");
const sys_log = () => import("@/components/base_business/system_log"); //系统日志修改
const user_flag = () => import("@/components/base_business/person_flag");
const user_role = () => import("@/components/base_business/user_role"); //角色
const user_dep = () => import("@/components/base_business/user_deparment"); //部门
const base_class = () => import("@/components/base_business/base_class"); //基础类型设置
const company = () => import("@/components/base_business/company"); //公司信息

const user_menu = () => import("@/components/base_business/user_menu"); //快捷菜单

const menusetphone = () => import("@/components/base_business/menu_set_phone"); //手机菜单内容设置

//自助建表
// const auto_build = () => import("@/components/auto/auto_build"); //建设主表
const td_build = () => import("@/components/auto/td_build"); //简单业务表初始化

export default [
	{
		name: "control_user",
		path: "/control_user",
		component: user_set,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "用户信息"
		}
	},
	{
		name: "user_menu",
		path: "/user_menu",
		component: user_menu,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "我的快捷菜单"
		}
	},
	{
		name: "menusetphone",
		path: "/menusetphone",
		component: menusetphone,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "手机菜单设定"
		}
	},
	{
		name: "control_role",
		path: "/control_role",
		component: user_role,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "角色设置"
		}
	},
	{
		name: "control_dep",
		path: "/control_dep",
		component: user_dep,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "部门设置"
		}
	},
	{
		name: "control_type",
		path: "/control_type",
		component: base_class,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "类型设置"
		}
	},
	{
		name: "company",
		path: "/company",
		component: company,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "公司信息"
		}
	},
	{
		name: "control_menu",
		path: "/control_menu",
		component: menu_set,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "菜单内容设置"
		}
	},
	{
		name: "sys_set",
		path: "/sys_set",
		component: sys_set,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "系统参数"
		}
	},
	{
		name: "sys_select",
		path: "/sys_select",
		component: sys_select,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "系统业务"
		}
	},
	{
		name: "c_menu_set",
		path: "/c_menu_set",
		component: c_menu_set,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "初始业务统计范围"
		}
	},
	{
		name: "home_set",
		path: "/home_set",
		component: home_set,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "首页提醒分配"
		}
	},
	{
		name: "home_base",
		path: "/home_base",
		component: home_base,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "首页提醒配置"
		}
	},
	{
		name: "control_log",
		path: "/control_log",
		component: sys_log,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "系统日志"
		}
	},
	{
		name: "control_pwd",
		path: "/control_pwd",
		component: pwd_set,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "密码修改"
		}
	},
	{
		name: "td_build",
		path: "/td_build",
		component: td_build,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "业务表初始化"
		}
	}
]